import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { Header as ExperimentHeader } from '../../sunriseHoldoutExperiment/components/Header';
import { useSunriseHoldoutExperiment } from '../../sunriseHoldoutExperiment/hooks/useSunriseHoldoutExperiment';

import { useHeader } from './hooks/useHeader';

export function Header(): JSX.Element {
	const { headline, description, isSunriseEnabled } = useHeader();
	const { enabled } = useSunriseHoldoutExperiment();

	if (enabled) {
		return <ExperimentHeader />;
	}

	return (
		<>
			<Box sx={{ mb: 16 }}>
				<Heading
					size="h3"
					data-qa="ppmu-modal-header-title"
					sx={{
						...(isSunriseEnabled && {
							color: 'sunrise.semantic.typography.strong',
						}),
					}}
				>
					{headline}
				</Heading>
			</Box>
			<Text
				data-qa="ppmu-modal-header-description"
				sx={{
					...(isSunriseEnabled && {
						color: 'sunrise.semantic.typography.strong',
					}),
				}}
			>
				{description}
			</Text>
		</>
	);
}
